/**
 * PostComments 骨架屏组件
 *
 * CLS 优化：为评论列表区域提供布局稳定的骨架屏
 *
 * 问题：初次加载评论时显示 "No comments yet"，评论加载完成后把区域撑高导致 CLS
 *
 * 解决：在 initialLoading 时显示与评论列表布局一致的骨架屏，保持容器高度稳定
 */
import { Skeleton } from 'antd';

interface PostCommentsSkeletonProps {
  /** 显示的骨架项数量，默认显示15条评论 */
  itemCount?: number;
}

export default function PostCommentsSkeleton({ itemCount = 15 }: PostCommentsSkeletonProps) {
  return (
    <div className="w-full">
      {/* 评论列表骨架 */}
      {Array.from({ length: itemCount }, (_, index) => (
        <div key={index} className="p-4 max-md:px-0 max-md:py-2.5">
          <div className="flex items-start gap-3">
            {/* 用户头像 */}
            <Skeleton.Avatar active size={40} />

            {/* 评论内容 */}
            <div className="flex-1 min-w-0">
              <div className="flex flex-col gap-1.5">
                {/* 用户名和时间 */}
                <div className="flex items-center gap-2">
                  <Skeleton.Input active style={{ width: 100, height: 16 }} />
                  <Skeleton.Input active style={{ width: 80, height: 14 }} />
                </div>
                {/* 评论文本 - 两行 */}
                <Skeleton.Input active style={{ width: '100%', height: 16 }} />
                <Skeleton.Input active style={{ width: '70%', height: 16 }} />
                {/* 点赞数 */}
                <div className="flex items-center gap-4 mt-1">
                  <Skeleton.Input active style={{ width: 50, height: 14 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
